<template>
  <b-modal no-fade v-model="dialog.show" size="xl" :id="`modal-symbol-${uniqueId}`"
           :hide-footer="true" centered @close="closeModal"
           no-close-on-backdrop
  >
    <template #modal-title>
     <span>
       {{ $t('tabs.trade.massOrder') }}
     </span>
    </template>
    <div style="min-height: 400px; position: relative;" v-if="dialog.show">
      <trade-order-mass-form-part v-model="tradeDetails"
                                  v-bind:stopPricesValidation="stopPricesValidation"
                                  @showGraph="showGraph=>dialog.showGraph=showGraph"
                                  @generateReport="executeAndReport"
      >
        <template #newTrade>
          <account-picker ref="accountPicker" v-model="accounts" multiple @input="setAccountsStr"/>
          <!--Data-->
          <b-row class="mt-2" v-if="accountLogin != null">
            <!--Graph-->
            <b-col cols="5" style="min-height: 300px" v-if="dialog.showGraph">
              <t-v-graph v-bind:selected-symbol="selectedSymbol"/>
            </b-col>

            <b-col v-bind:cols="dialog.showGraph ? 6 : 12">
              <!-- Symbol Data -->
              <trade-order-symbol-data-part v-model="tradeDetails" v-bind:dialog="dialog" v-bind:lastTick="lastTick" v-bind:symbols="symbols" default-lots-percent/>
              <!--Trade Price New-->
              <trade-order-new-prices-part  v-model="tradeDetails" v-bind:account="account" v-bind:lastTick="lastTick"
                                           v-bind:symbols="symbols" v-bind:stopPricesValidation="stopPricesValidation"
              />
              <!--Commission-->
              <trade-order-commission-part v-model="tradeDetails"/>
              <!--Comment-->
              <b-row class="mt-1">
                <b-col cols="12">
                  <b-input-group size="sm" prepend="comment" style="width: 100%">
                    <b-input v-model="tradeDetails.comment"></b-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
        <template #revision>
          <trade-order-new-revision-part v-model="tradeDetails">
            <template #header>
              <b-col cols="2"><h5>{{$t('columns.accounts')}}:</h5></b-col>
              <b-col cols="9">{{accountsStr}}</b-col>
            </template>
          </trade-order-new-revision-part>
        </template>
        <template #report>
          <div class="mass-order-report">
            <b class="d-block text-center mb-1">Transaction: {{tradeDetails.groupTransactionId}}</b>
            <div class="flex-column align-items-start border py-1 rounded mb-2" v-for="report in tradeReports" :key="report.accountId">
              <b-row>
                <b-col cols="1" align-self="center" class="text-center trade-operation-status">
                  <b-spinner v-if="report.isPending" variant="success" label="Spinning"></b-spinner>
                  <b-icon v-if="report.isCompleted" icon="check" variant="success" font-scale="3"></b-icon>
                  <!--<b-icon icon="x-circle" variant="danger" font-scale="3"></b-icon>-->
                  <b-icon v-if="report.isError" icon="x" variant="danger" font-scale="3"></b-icon>
                </b-col>
                <b-col cols="11" class="trade-operation-status">
                  <b class="text-capitalize-">{{report.accountName}}</b>
                  <p class="mb-0" v-if="report.isCompleted">Successfully completed order {{report.trade.order}} of {{ report.trade.lots }} lots of {{ report.trade.symbolName }}</p>
                  <p class="mb-0" v-if="report.isError">{{report.errorMessage}}</p>
                </b-col>
              </b-row>
            </div>
          </div>
        </template>
      </trade-order-mass-form-part>
    </div>
  </b-modal>
</template>

<script>
import AccountPicker from '@/components/widget/picker/accountPicker.vue'
import TradeOrderCommissionPart from '@/components/modal/tradeOrderModalPart/tradeOrderCommissionPart.vue'
import TradeOrderNewPricesPart from '@/components/modal/tradeOrderModalPart/TradeOrderNewPricesPart.vue'
import TVGraph from '@/components/graph/TVGraph.vue'
import TradeOrderSymbolDataPart from '@/components/modal/tradeOrderModalPart/tradeOrderSymbolDataPart.vue'
import { mapActions, mapGetters } from 'vuex'
import TradeRequest from '@/model/trade/TradeRequest'
import { TradeCmdEnum } from '@/model/trade/TradeCmdEnum'
import TradeOrderFormPart from '@/components/modal/tradeOrderModalPart/tradeOrderFormPart.vue'
import TradeOrderMassFormPart from '@/components/modal/tradeOrderModalPart/tradeOrderMassFormPart.vue'
import TradeOrderNewRevisionPart from '@/components/modal/tradeOrderModalPart/TradeOrderNewRevisionPart.vue'
import mixinBase from '@/components/mixin/mixinBase'

export default {
  name: 'tradeMassOderModal',
  mixins: [mixinBase],
  components: {
    TradeOrderNewRevisionPart,
    TradeOrderMassFormPart,
    TradeOrderFormPart,
    TradeOrderSymbolDataPart,
    TVGraph,
    TradeOrderNewPricesPart,
    TradeOrderCommissionPart, AccountPicker },
  data: () => ({
    dialog: {
      show: false,
      showGraph: false
    },
    uniqueId: 0,
    accounts: [],
    tradeDetails:{},
    symbols: [],
    lastTick: {},
    tradeReports: [],
    accountsStr: '',
  }),
  watch: {
    'accounts'(){
      if(this.accounts.length === 1){
        this.refreshSymbols()
      }
    },
    ['tradeDetails.symbolId'](){
      this.refreshTicker()
    }
  },
  created() {
    this.uniqueId = this._uid;
  },
  mounted() {
    // this.intervalId = setInterval(this.refreshTicker, 5*1000)
    this.$root.$on('system::tickers::updated', this.refreshTicker)
  },
  beforeDestroy() {
    //  clearInterval(this.intervalId)
    this.$root.$off('system::tickers::updated', this.refreshTicker)
  },
  computed:{
    ...mapGetters('symbol', ['getTicker']),
    accountLogin(){
      if(this.accounts.length>0){
        return this.accounts[0]
      }
      return null
    },
    account(){
      if(this.accountLogin != null && this.$refs.accountPicker != null){
        return this.$refs.accountPicker.getAccountById(this.accountLogin)
      }
      return null
    },
    accountMap(){
      if(this.accounts == null || this.accounts.length<=0 || this.$refs.accountPicker == null){
        return []
      }
      if(this.accounts == null || this.accounts.length<=0){
        return []
      }
      return this.$refs.accountPicker.getAccountMap()
    },

    selectedSymbol(){
      if(this.tradeDetails == null || this.tradeDetails.symbolId == null){
        return null
      }
      return this.symbols.find(symbol => symbol.id === this.tradeDetails.symbolId)
    },
    /////tradeOrderModal methods//////
    stopPricesValidation() {
      let stopPrices = {tp:true, sl:true}
      if(this.trade == null || this.tradeDetails == null){
        return stopPrices
      }
      let symbol = this.symbols.find(symbol => symbol.id === this.tradeDetails.symbolId)
      let currentPrice = isNaN(this.tradeDetails.openPrice) ? 0 : this.tradeDetails.openPrice
      if(symbol == null || currentPrice == null){
        return stopPrices
      }
      stopPrices.tp = !this.tradeDetails.isOpen || this.tradeDetails.tp == null || this.tradeDetails.tp === "" || (!isNaN(this.tradeDetails.tp) && this.tradeDetails.tp > currentPrice)
      stopPrices.sl = !this.tradeDetails.isOpen || this.tradeDetails.sl == null || this.tradeDetails.sl === "" || (!isNaN(this.tradeDetails.sl) && this.tradeDetails.sl < currentPrice)
      return stopPrices
    },
    /////end tradeOrderModal computed//////
  },
  methods: {
    ...mapActions('symbol', ['getAvailableSymbols']),
    ...mapActions('trade', ['getLastTick', 'placeOrder']),
    showModal(selectedIds) {
      console.log("tradeMassOderModal showModal", selectedIds)
      if(Array.isArray(selectedIds) && selectedIds.length > 0){
        this.accounts = [...selectedIds]
        this.refreshSymbols();
      }
      this.dialog.show = true
      this.tradeDetails = TradeRequest({
        command: TradeCmdEnum.BUY,
        symbol: 'EURUSD',
        symbolId: 'EUR/USD',
        lots: 1,
        openPrice: 0,
        currentOpenTime: true,
        currentOpenPrice: true,
        isLotsPercent: false,
        groupTransactionId: `mo-${this.$moment().utc().format('YYYYMMDD-HHmmss')}`,
        openTime: this.$moment().utc()
            .format('YYYY-MM-DD HH:mm'),
      })
    },
    setAccountsStr(){
      if(this.accounts == null || this.accounts.length<=0 || this.$refs.accountPicker == null){
        this.accountsStr = ""
        return
      }
      let accountsMap = this.$refs.accountPicker.getAccountMap()
      this.accountsStr =  this.accounts
          .map(id=>accountsMap[id] || {})
          .map(acc=>acc.id + " - " + acc.name)
          .join(", ")
    },
    /////tradeOrderModal methods//////
    async refreshSymbols() {
      console.log('refreshSymbols')
      try{
        let originalTotalSymbols = this.symbols?.length || 0
        this.symbols = await this.getAvailableSymbols(this.accountLogin);
        if (originalTotalSymbols === 0 && this.symbols.length > 0) {
          // this.tradeDetails.symbolId = this.symbols[0].id
          this.refreshTicker()
        }
      }catch (e) {
        this.showServerErrorNotification('fetchDataError', 'symbol', e)
        this.closeModal();
      }finally{
        this.loading = false
      }
    },
    async refreshTicker() {
      if (this.dialog.show !== true) return
      if (this.accountLogin == null) return
      console.log('refreshTicker', this.tradeDetails.symbolId)
      let lastTick = this.getTicker(this.tradeDetails.symbolId)
      if (lastTick == null) {
        let tick = await this.getLastTick({
          account: this.accountLogin,
          symbols: [this.tradeDetails.symbolId]
        });
        if(Array.isArray(tick) && tick.length>0) {
          this.lastTick = tick[0]
        }
      } else {
        console.log('lastTick', lastTick)
        this.lastTick = lastTick
      }
    },
    executeAndReport() {
      let $this = this
      this.accounts.forEach(account => {
        let accountTradeReport = {
          isPending: true, isCompleted: false, isError: false, errorMessage: null, accountId: account,
          accountName: (this.accountMap[account] ? `${account} - ${this.accountMap[account].name}` : account),
          trade: null
        }
        $this.placeOrder({account:account, order: $this.tradeDetails})
            .then(tradeResponse => {
              console.log("placeOrder completed", { tradeResponse, accountTradeReport })
              accountTradeReport.isPending = false
              accountTradeReport.isCompleted = true
              accountTradeReport.trade = tradeResponse
            })
            .catch(err => {
              console.log("placeOrder error", { err, accountTradeReport })
              accountTradeReport.isPending = false
              accountTradeReport.isError = true
              accountTradeReport.errorMessage = $this.getErrorDescription(err) || err.message || 'Unknown error'
            })
        $this.tradeReports.push(accountTradeReport)
      })
    },
    /////end tradeOrderModal methods//////
    closeModal(){
      this.accounts = []
      this.tradeReports = []
      this.tradeDetails = {}
      // this.dialog.show = false;
      // this.$emit('close');
    }
  }
}
</script>


<style lang="scss">
.mass-order-report {
  .list-group-item-action:hover,
  .list-group-item-action:focus,
  .list-group-item-action:active {
    background: inherit !important;
  }
}
</style>